import React, { useContext, useEffect, useState } from 'react'
import Header from "../headerAdmin/Header.js"
import './requisitionReports.css'
import ArrowBack from '@mui/icons-material/ArrowBack';
import JobReport from './JobReport.js';
import SubmissionReport from './SubmissionReport.js';
import WorkReport from './WorkReport.js';
import RecruitersActivity from './RecruitersActivity.js';
import Excel from "../Icons/excel.js";
import { useLocation, useNavigate  } from "react-router-dom";
import Tooltip from '@mui/material/Tooltip';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
    NotificationManager,
} from "react-notifications";
import JobReportSearch from './SearchBox/JobReportSearch.js';
import getAllDivionByOrg from '../../apis/getAllDivionByOrg/getAllDivisionByOrg.js';
import { getClientByOrg } from '../../apis/organisationAdminAPI/manageClient.js';
import HiringReport from './HiringReport.js';
import AccessReport from './AccessReport.js';
import ActivityReport from './ActivityReport.js';
import getAllTeamByOrgId from '../../apis/teambyOrganizationId/getAllTeamByOrgId.js';
import ResumeReport from './resume-report.js';
import RtrRports from './RtrRports.js';
import UnauthorizedAccess from '../UnauthorizedAccess/UnauthorizedAccess.js';
import { UserTypeContext } from '../../AppRoute.js';
import Testinvitatioreport from './testinvitatioreport.js';


const RequisitionReports = (props) => {
    const location = useLocation();
    const [selectedTab, setSelectedTab] = useState(`Job Report`)
    const { userType, userRecords } = useContext(UserTypeContext);
    const history = useNavigate();
    const userIdType = location?.state?.id ? location?.state?.id : userRecords?.id;
      const userRole = location?.state?.userRole ? location?.state?.userRole : userRecords?.role?.roleName;
      const userRecruitmentpartnerId = location?.state?.userRecruitmentpartnerId ? location?.state?.userRecruitmentpartnerId : userRecords?.recruitmentpartnerId;

    const [startSelectedDate, setStartSelectedDate] = useState(new Date(new Date().getTime() - 5 * 24 * 60 * 60 * 1000));
    const [endSelectedDate, setEndSelectedDate] = useState(new Date());
    const [triggerWorkReportAction, setTriggerWorkReportAction] = useState(false);
    const [triggerJobReportAction, setTriggerJobReportAction] = useState(false);
    const [triggerSubmissionReportAction, setTriggerSubmissionReportAction] = useState(false);
    const [triggerRecruiterActivityReportAction, setTriggerRecruiterActivityReportAction] = useState(false);
    const [triggerHiring, setTriggerHiring] = useState(false);
    const [triggerAccess, setTriggerAccess] = useState(false);
    const [triggerActivity, setTriggerActivity] = useState(false);
    const [triggerResume, setTriggerResume] = useState(false);
    const [triggerRTR, setTriggerRTR] = useState(false);
    const [triggerTestInvitationReport, setTriggerTestInvitationReport] = useState(false);



    const [isfilterSearch, setIsfilterSearch] = useState(false)

    const [filterValues_accessreport, setFilterValues_accessreport] = useState({ email: [], ipAddress: [] });
    const [additionalFilter, setAdditionalFilter] = useState({
        "placementType": [],
        "clientName": [],
        "divisionId": [],
        "requisitionStatus": [],
        "requisionSubStatus": [],
        "start_date": "",
        "interview_date": "",
        "offer_release_date": "",
        "clientJobId":"",
        // "joining_date" : ""
    })

    const [additionalFilter_submission, setAdditionalFilter_submission] = useState({
        "clientName": [],
        "divisionId": [],
        "teamId":[],
        "start_date": "",
        "selected_date": "",
        "joining_date": "",
        "interview_date": "",
        "offer_release_date": "",
        "statusList": [],
        "clientJobId":"",
    })

    const [additionalFilter_activity, setAdditionalFilter_activity] = useState({
        "name": "",
        "email": "",
    })
    const [additionalFilter_workReport, setAdditionalFilter_workReport] = useState({
        "clientName": [],
        "divisionId": [],
        "start_date": "",
        "selected_date": "",
        "interview_date": "",
        "offer_release_date": "",
        "clientJobId":"",
    })

    const [additionalFilter_recruiter_activity, setAdditionalFilter_recruiter_activity] = useState({
        "clientName": [],
        "divisionId": [],
    })

    const [additionalFilter_resume_report, setAdditionalFilter_resume_report] = useState({
        "divisionId": [],
        "teamId":[],
        "email": "",
    })

    const [additionalFilter_rtr_report, setAdditionalFilter_rtr_report] = useState({
        "clientName": [],
        "divisionId": [],
        "teamId":[],
        "candidateName": "",
        "candidateEmail": "",
        "refId": "",
        "rtrStatus": "",
        "rtrSendDate": {
            from: "",
            to: ""
        },
        "approvalDate": {
            from: "",
            to: ""
        },
        "rejectDate": {
            from: "",
            to: ""
        }
    })


    const [allDivisionNames, setAllDivisionNames] = useState([])
    const [allClientNames, setAllClientNames] = useState([])
    const [allTeamNames, setAllTeamNames] = useState([])


    const getRequisitionDetail = async () => {
        try {

            let payload = {
                isManageClient: false
            }
            let divisionResponse = await getAllDivionByOrg(userRecruitmentpartnerId, payload);
            const names = divisionResponse?.data?.data;
            setAllDivisionNames(names);
        } catch (error) {
            console.log(error)
        }

    }
    const getAllClientByOrg = async () => {
        let payload = {
            recruitmentPartnerId: userRecruitmentpartnerId,
            isActive: true
        }
        try {
            let response = await getClientByOrg(payload);
            setAllClientNames(response.data.data)
        } catch (error) {
            console.log(error)
        }
    }

    const getAllTeamByOrg = async () => {
        try {
            let response = await getAllTeamByOrgId({ recruitmentpartnerId: userRecruitmentpartnerId, isActive: true });
            setAllTeamNames(response.data.data)
        } catch (error) {
            console.log(error)
        }
    }


    useEffect(() => {
        getRequisitionDetail()
        getAllClientByOrg()
        getAllTeamByOrg()
    }, [])





    const gotoDashBoard = () => {
        if (userType === "MIS Operator" || (userType === "Admin" && userRole === "MIS Operator")) {
            history("/requisition-dashboard",
                {state: { id: userIdType, recruitementPartnerId: userRecruitmentpartnerId, userType: userType, userRecords: userRecords, userRole: userRole },
            });
        } else {
            history( "/dashboard",{
                state: {
                    userType: userType,
                    recruitmentPartnerId: userRecruitmentpartnerId,
                    id: userIdType,
                    userRecords: userRecords,
                    roleName: userRole
                }
            });
        }

    }




    const exportExcel = () => {

        const formattedDatestart = startSelectedDate.toISOString();
        const formattedDateend = endSelectedDate.toISOString();

        // Calculate time difference in milliseconds
        const timeDiff = new Date(formattedDateend).getTime() - new Date(formattedDatestart).getTime();

        // Convert time difference to days
        const diffDays = Math.round(timeDiff / (1000 * 3600 * 24));

        if (diffDays <= 365 && diffDays > -1) {
            if (selectedTab === 'Work Report') {
                setTriggerWorkReportAction(true); // This triggers the child action
            } else if (selectedTab === 'Job Report') {
                setTriggerJobReportAction(true);
            } else if (selectedTab === 'Submission Report') {
                // console.log({ additionalFilter_submission })
                setTriggerSubmissionReportAction(true);
            } else if (selectedTab === "Recruiter's Activity") {
                setTriggerRecruiterActivityReportAction(true);
            } else if (selectedTab === "Hiring Report") {
                setTriggerHiring(true);
            }
            else if (selectedTab === "Access log Report") {
                setTriggerAccess(true);
            }
            else if (selectedTab === "Activity Report") {
                setTriggerActivity(true);
            }
            else if (selectedTab === "Resume Report") {
                setTriggerResume(true);
            }
            else if (selectedTab === "RTR Reports") {
                setTriggerRTR(true);
            }
            else if (selectedTab === "testinvitationreport") {
                setTriggerTestInvitationReport(true);
            }

        } else {
            NotificationManager.error(
                "Duration of Selected date should be less than 1 year",
                "Error",
                10000
            );
        }
    }

    const startDateChangeHandler = (date) => {
        setStartSelectedDate(date);
    };

    const endDateChangeHandler = (date) => {
        setEndSelectedDate(date);
    }

    useEffect(() => {
        setAdditionalFilter(
            {
                "placementType": [],
                "clientName": [],
                "divisionId": [],
                "requisitionStatus": [],
                "requisionSubStatus": [],
                "start_date": "",
                "interview_date": "",
                "offer_release_date": "",
                "clientJobId":"",
            }
        )
        setAdditionalFilter_workReport({
            "clientName": [],
            "divisionId": [],
            "teamId":[],
            "start_date": "",
            "selected_date": "",
            "interview_date": "",
            "offer_release_date": "",
            "clientJobId":"",

        })
        setAdditionalFilter_submission({
            "clientName": [],
            "divisionId": [],
            "teamId":[],
            "start_date": "",
            "selected_date": "",
            "interview_date": "",
            "offer_release_date": "",
            "joining_date": "",
            "statusList": [],
            "clientJobId":"",
        })
        setAdditionalFilter_recruiter_activity({
            "clientName": [],
            "divisionId": [],
        })

        setFilterValues_accessreport({
            "email": [],
            "ipAddress": [],
        })

        setAdditionalFilter_activity({
            "name": "",
            "email": "",
        })
        setAdditionalFilter_resume_report({
            "divisionId": [],
            "teamId":[],
            "email": "",

        })
        
        setAdditionalFilter_rtr_report({
            "clientName": [],
            "divisionId": [],
            "teamId":[],
            "candidateName": "",
            "candidateEmail": "",
            "refId": "",
            "rtrStatus": "",
            "rtrSendDate": {
                from: "",
                to: ""
            },
            "approvalDate": {
                from: "",
                to: ""
            },
            "rejectDate": {
                from: "",
                to: ""
            }
        })

    }, [selectedTab])



    return (<>

        {((userType === "Admin") || (userType === "Recruitment Leader") || (userType === "Organization Admin") || (userType === "MIS Operator") || (userType === "Team Leader")) ?
            <>

                <div className='mainContainer_requisitionReports'>
                    <div className='topContainer_requisitionReports'>
                        <Header />
                        <div className='mainDiv_requisitionReports'>
                            
                            <div className='gobackContainer_requisitionReports'>
                                <div className="reportHeader_requisitionReports">
                                    <Tooltip title={userType === "MIS Operator" ? "Go Back to Requisition Dashboard" : "Go Back to Dashboard"} placement="bottom">
                                        <div className="goBackButton_requisitionReports" onClick={(e) => gotoDashBoard()}>
                                            <ArrowBack sx={{ fontSize: 20 }} />
                                            {/* <span>&nbsp;{userType === "MIS Operator" ? "Go Back to Requisition Dashboard" : "Go Back to Dashboard"}</span> */}
                                        </div>
                                    </Tooltip>
                                    <div className="reportTitle_requisitionReports">Reports</div>
                                </div>
                                <div className='right_side_requisitionReports_exports_date'>
                                    <div className='dateRangeContainer_requisitionReports'>
                                        <span className='dateRangeContainer_requisitionReports_text'>Date Range : </span>
                                        <div className='datePicker_Container'>
                                            <DatePicker
                                                className="createRequisition_textbox_datapicker_reports"
                                                selected={startSelectedDate}
                                                onChange={startDateChangeHandler}
                                                value={startSelectedDate}
                                                dateFormat="MM/dd/yyyy"
                                                showIcon
                                            // minDate={new Date()}
                                            />
                                        </div>
                                        <span className='dateRangeContainer_requisitionReports_text'>to</span>
                                        <div className='datePicker_Container'>
                                            <DatePicker
                                                className="createRequisition_textbox_datapicker_reports"
                                                selected={endSelectedDate}
                                                onChange={endDateChangeHandler}
                                                value={endSelectedDate}
                                                dateFormat="MM/dd/yyyy"
                                                showIcon
                                            // minDate={new Date()}
                                            />
                                        </div>
                                    </div>
                                    <button onClick={exportExcel} className="exportExcelBtn_requisitionReports">
                                        <Excel size={30} className='excelImg_requisitionReports' alt="excelImg" />
                                        <span>Export</span>
                                    </button>
                                </div>

                            </div>

                            <div className="mainContentContainer_requisitionReports">
                                {selectedTab !== "testinvitationreport" &&
                                    <div className='sideContainer_requisitionReports'>
                                        <JobReportSearch selectedTab={selectedTab} setAdditionalFilter={setAdditionalFilter} additionalFilterData={additionalFilter} allDivisionNames={allDivisionNames} setAdditionalFilter_recruiter_activity={setAdditionalFilter_recruiter_activity} setAdditionalFilter_workReport={setAdditionalFilter_workReport} setAdditionalFilter_submission={setAdditionalFilter_submission} allClientNames={allClientNames} setIsfilterSearch={setIsfilterSearch} setFilterValues_accessreport={setFilterValues_accessreport} setAdditionalFilter_activity={setAdditionalFilter_activity} setAdditionalFilter_resume_report={setAdditionalFilter_resume_report} allTeamNames={allTeamNames} setAdditionalFilter_rtr_report={setAdditionalFilter_rtr_report}/>
                                    </div>
                                }
                                <div className={`wrapperContainer_requisitionReports ${selectedTab === 'testinvitationreport' ? 'fullWidth_requisitionReports' : ''}`}>
                                    <div className='tabButtonsWrapper_requisitionReports'>
                                        <div className={selectedTab === 'Job Report' ? 'tabButton_requisitionReports tabActive_requisitionReports' : 'tabButton_requisitionReports'} onClick={(e) => setSelectedTab('Job Report')}>Job Report</div>
                                        <div className={selectedTab === 'Submission Report' ? 'tabButton_requisitionReports tabActive_requisitionReports' : 'tabButton_requisitionReports'} onClick={(e) => setSelectedTab('Submission Report')}>Submission Report</div>
                                        <div className={selectedTab === 'Work Report' ? 'tabButton_requisitionReports tabActive_requisitionReports' : 'tabButton_requisitionReports'} onClick={(e) => setSelectedTab('Work Report')}>Work Report</div>
                                        <div className={selectedTab === `Recruiter's Activity` ? 'tabButton_requisitionReports tabActive_requisitionReports' : 'tabButton_requisitionReports'} onClick={(e) => setSelectedTab(`Recruiter's Activity`)}>Recruiter's Activity</div>
                                        <div className={selectedTab === "Hiring Report" ? 'tabButton_requisitionReports tabActive_requisitionReports' : 'tabButton_requisitionReports'} onClick={(e) => setSelectedTab("Hiring Report")}>Hiring Report</div>
                                        <div className={selectedTab === "Access log Report" ? 'tabButton_requisitionReports tabActive_requisitionReports' : 'tabButton_requisitionReports'} onClick={(e) => setSelectedTab("Access log Report")}>Access log Report</div>
                                        <div className={selectedTab === "Activity Report" ? 'tabButton_requisitionReports tabActive_requisitionReports' : 'tabButton_requisitionReports'} onClick={(e) => setSelectedTab("Activity Report")}>Activity Report</div>
                                        <div className={selectedTab === "Resume Report" ? 'tabButton_requisitionReports tabActive_requisitionReports' : 'tabButton_requisitionReports'} onClick={(e) => setSelectedTab("Resume Report")}>Resume Report</div>
                                        <div className={selectedTab === "RTR Reports" ? 'tabButton_requisitionReports tabActive_requisitionReports' : 'tabButton_requisitionReports'} onClick={(e) => setSelectedTab("RTR Reports")}>RTR Reports</div>
                                        {(userType === "MIS Operator" || userType === "Organization Admin") &&
                                            <div className={selectedTab === "testinvitationreport" ? 'tabButton_requisitionReports tabActive_requisitionReports' : 'tabButton_requisitionReports'} onClick={(e) => setSelectedTab("testinvitationreport")}>Test Invitation Report</div>
                                        }
                                    </div>
                                    <div className='gridContainer_requisitionReports'>
                                        <div className='kendoContainer_requisitionReports'>
                                            {/* <div className='export-button'>
                                                <Typography>Search Results for {selectedTab}</Typography>
                                            </div> */}

                                        {selectedTab === 'Job Report' && <JobReport isfilterSearch={isfilterSearch} setIsfilterSearch={setIsfilterSearch} additionalFilterData={additionalFilter} userType={userType === 'Admin' ? userRole : userType} userIdType={userIdType} userRecruitmentpartnerId={userRecruitmentpartnerId} userRecords={userRecords}
                                            triggerAction={triggerJobReportAction} resetTrigger={() => setTriggerJobReportAction(false)} startSelectedDate={startSelectedDate} endSelectedDate={endSelectedDate} />}
                                        {selectedTab === 'Submission Report' && <SubmissionReport isfilterSearch={isfilterSearch} setIsfilterSearch={setIsfilterSearch} additionalFilterData={additionalFilter_submission} userType={userType === 'Admin' ? userRole : userType} userIdType={userIdType} initator={"requisitionReport"} userRecruitmentpartnerId={userRecruitmentpartnerId} userRecords={userRecords}
                                            triggerAction={triggerSubmissionReportAction} resetTrigger={() => setTriggerSubmissionReportAction(false)} startSelectedDate={startSelectedDate} endSelectedDate={endSelectedDate} />}
                                        {selectedTab === 'Work Report' && <WorkReport isfilterSearch={isfilterSearch} setIsfilterSearch={setIsfilterSearch} additionalFilterData={additionalFilter_workReport} userType={userType === 'Admin' ? userRole : userType} userIdType={userIdType} userRecruitmentpartnerId={userRecruitmentpartnerId} userRecords={userRecords}
                                            triggerAction={triggerWorkReportAction} resetTrigger={() => setTriggerWorkReportAction(false)} startSelectedDate={startSelectedDate} endSelectedDate={endSelectedDate} />}
                                        {selectedTab === "Recruiter's Activity" && <RecruitersActivity isfilterSearch={isfilterSearch} setIsfilterSearch={setIsfilterSearch} additionalFilterData={additionalFilter_recruiter_activity} userType={userType === 'Admin' ? userRole : userType} userIdType={userIdType} userRecruitmentpartnerId={userRecruitmentpartnerId} userRecords={userRecords}
                                            triggerAction={triggerRecruiterActivityReportAction} resetTrigger={() => setTriggerRecruiterActivityReportAction(false)} startSelectedDate={startSelectedDate} endSelectedDate={endSelectedDate} />}

                                        {selectedTab === "Access log Report" &&
                                            <AccessReport isfilterSearch={isfilterSearch}
                                                userType={userType === 'Admin' ? userRole : userType} userIdType={userIdType}
                                                userRecruitmentpartnerId={userRecruitmentpartnerId} userRecords={userRecords}
                                                startSelectedDate={startSelectedDate}
                                                endSelectedDate={endSelectedDate}
                                                exports={triggerAccess}
                                                setTriggerAccess={setTriggerAccess}
                                                additionalFilter={filterValues_accessreport}
                                            />}
                                        {selectedTab === "Activity Report" &&
                                            <ActivityReport isfilterSearch={isfilterSearch}
                                                userType={userType === 'Admin' ? userRole : userType} userIdType={userIdType}
                                                userRecruitmentpartnerId={userRecruitmentpartnerId} userRecords={userRecords}
                                                startSelectedDate={startSelectedDate}
                                                endSelectedDate={endSelectedDate}
                                                exports={triggerActivity}
                                                setTriggerActivity={setTriggerActivity}
                                                additionalFilter={additionalFilter_activity}
                                            />}

                                        {selectedTab === "Hiring Report" &&
                                            <HiringReport isfilterSearch={isfilterSearch}
                                                filter={additionalFilter}
                                                userType={userType === 'Admin' ? userRole : userType} userIdType={userIdType}
                                                userRecruitmentpartnerId={userRecruitmentpartnerId} userRecords={userRecords}
                                                startSelectedDate={startSelectedDate}
                                                endSelectedDate={endSelectedDate}
                                                exports={triggerHiring}
                                                setTriggerHiring={setTriggerHiring}
                                            />}
                                        {selectedTab === "Resume Report" &&
                                            <ResumeReport isfilterSearch={isfilterSearch}
                                                filter={additionalFilter_resume_report}
                                                userType={userType === 'Admin' ? userRole : userType} userIdType={userIdType}
                                                userRecruitmentpartnerId={userRecruitmentpartnerId} userRecords={userRecords}
                                                startSelectedDate={startSelectedDate}
                                                endSelectedDate={endSelectedDate}
                                                exports={triggerResume}
                                                setTriggerResume={setTriggerResume}
                                            />}
                                        {selectedTab === "RTR Reports" &&
                                            <RtrRports isfilterSearch={isfilterSearch}
                                                filter={additionalFilter_rtr_report}
                                                userType={userType === 'Admin' ? userRole : userType} userIdType={userIdType}
                                                userRecruitmentpartnerId={userRecruitmentpartnerId} userRecords={userRecords}
                                                startSelectedDate={startSelectedDate}
                                                endSelectedDate={endSelectedDate}
                                                exports={triggerRTR}
                                                setTriggerRTR={setTriggerRTR}
                                            />}
                                        {
                                            selectedTab === "testinvitationreport" && (userType === "MIS Operator" || userType === "Organization Admin" ) &&
                                            <Testinvitatioreport 
                                                isfilterSearch={isfilterSearch}
                                                setIsfilterSearch={setIsfilterSearch}
                                                userType={userType === 'Admin' ? userRole : userType} userIdType={userIdType}
                                                userRecruitmentpartnerId={userRecruitmentpartnerId} userRecords={userRecords}
                                                startSelectedDate={startSelectedDate}
                                                endSelectedDate={endSelectedDate}
                                                exports={triggerTestInvitationReport}
                                                setTriggerTestInvitationReport={setTriggerTestInvitationReport}
                                            />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
            :
            <>
                <UnauthorizedAccess />
            </>
        }
    </>
    )
}

export default RequisitionReports

